// apiServices.js

import axios from "axios";
const axiosInstanceMultipart = axios.create({
  baseURL: process.env.REACT_APP_PLEXAAR_CHATNCALL_API, // Replace with your API base URL
  timeout: 20000, // Adjust the timeout as needed
  headers: {
    "Content-Type": "multipart/form-data", // Change Content-Type to handle FormData
    // Add any common headers here
  },
});

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_PLEXAAR_CHATNCALL_API, // Replace with your API base URL
  timeout: 10000, // Adjust the timeout as needed
  headers: {
    "Content-Type": "application/json",
    // Add any common headers here
  },
});

const axiosInstancePlexaarEmailApi = axios.create({
  baseURL: process.env.REACT_APP_PLEXAAR_EMAIL_API, // Replace with your API base URL
  timeout: 10000, // Adjust the timeout as needed
  headers: {
    "Content-Type": "application/json",
    // Add any common headers here
  },
});
console.log("ENV VALUE", process.env.REACT_APP_PLEXAAR_URL);

const axiosInstancePlexaar = axios.create({
  baseURL: process.env.REACT_APP_PLEXAAR_URL, // Replace with your API base URL
  timeout: 10000, // Adjust the timeout as needed
  headers: {
    "Content-Type": "application/json",
    // Add any common headers here
  },
});

// Define your API services as functions

const apiServices = {
  async getUserById(userId) {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PLEXAAR_URL}/signup_svc/pv/users/getUserById?id=${userId}`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            userid: localStorage.getItem("encuserid"),
          },
        }
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  async updateUserById(data) {
    try {
      const response = await axiosInstance.put(`/user/update/info`, data);
      return response.data;
    } catch (error) {
      return error;
    }
  },

  async sendPushKit(data) {
    try {
      const response = await axiosInstance.post(
        `/notification/sendCallKitNotification`,
        data
      );
      return response;
    } catch (error) {
      return error;
    }
  },

  async seenMessages(conversationId, userId) {
    try {
      const response = await axiosInstance.get(
        `/message/mark/seen?conversationId=${conversationId}&userId=${userId}`
      );
      return response;
    } catch (error) {
      return error;
    }
  },
  async cancelRequest(obj) {
    try {
      const response = await axiosInstance.post("/contact/cancel", obj);
      return response;
    } catch (error) {
      return error;
    }
  },

  async filterContact(id, status, conversationId) {
    try {
      let response;
      if (conversationId) {
        response = await axiosInstance.get(
          `/contact/filter/?conversationId=${conversationId}`
        );
      } else {
        response = await axiosInstance.get(
          `/contact/filter/?requestedBy=${id}&status=${status}`
        );
      }
      return response.data;
    } catch (error) {
      return error;
    }
  },
  async createReport(obj) {
    try {
      const response = await axiosInstance.post("/reports/", obj);
      return response;
    } catch (error) {
      return error;
    }
  },
  async blockContact(obj) {
    try {
      const response = await axiosInstance.post("/contact/block", obj);
      return response;
    } catch (error) {
      return error;
    }
  },

  async deleteContact(obj) {
    try {
      const response = await axiosInstance.delete("/contact/deleteContact", {
        data: obj, // Use params to send data as query parameters
      });
      return response?.data;
    } catch (error) {
      return error;
    }
  },

  async search(query, currentUserId) {
    try {
      const response = await axiosInstance.get(
        `/user/search?query=${query}&currentUserId=${currentUserId}`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  async declineRequest(obj) {
    try {
      const response = await axiosInstance.post("/contact/decline", obj);
      return response;
    } catch (error) {
      return error;
    }
  },
  async acceptRequest(obj) {
    try {
      const response = await axiosInstance.post("/contact/acceptRequest", obj);
      return response;
    } catch (error) {
      return error;
    }
  },
  async signInUser(data) {
    try {
      const response = await axiosInstancePlexaar.post(
        "/signup_svc/pb/users/signIn",
        data
      );
      return response;
    } catch (error) {
      return error;
    }
  },

  async createContact(obj) {
    try {
      const response = await axiosInstance.post("/contact/createContact", obj);
      return response.data;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  },

  async getAllContacts(obj) {
    // let obj = {
    //   userId: "195",
    //   userName: "Drow Ranger",
    // };
    try {
      const response = await axiosInstance.post("/contact/getAllContacts", obj);
      return response.data;
    } catch (error) {
      return error;
    }
  },

  async deleteMessage(id) {
    try {
      const response = await axiosInstance.get(`/message/remove?id=${id}`);
      return response.data;
    } catch (error) {
      return error;
    }
  },
  async updateMessage(obj) {
    try {
      const response = await axiosInstance.post("/message/update", obj);
      return response.data;
    } catch (error) {
      return error;
    }
  },
  async getAllMessages(conversationId, pageNo) {
    try {
      const response = await axiosInstance.get(
        `/message/get/${conversationId}?page=${pageNo}&limit=100`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },
  // Example POST request
  async createResource(newResource) {
    try {
      const response = await axiosInstance.post("/resources", newResource);
      return response.data;
    } catch (error) {
      return error;
    }
  },

  async uploadAttachments(newResource) {
    try {
      const response = await axiosInstanceMultipart.post(
        "/media/uploadAttachments",
        newResource
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  async deleteUploadAtachments(newResource) {
    try {
      const response = await axiosInstance.post(
        "/media/delete-blob",
        newResource
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  async sendCallAccept(data) {
    try {
      const response = await axiosInstance.post(
        "/notification/sendAcceptCall",
        data
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  async sendCallDecline(data) {
    try {
      const response = await axiosInstance.post(
        "/notification/sendDeclineCall",
        data
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  async sendCallEnded(data) {
    try {
      const response = await axiosInstance.post(
        "/notification/sendEndedCall",
        data
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  async sendCallWithdraw(data) {
    try {
      const response = await axiosInstance.post(
        "/notification/sendWithDrawCall",
        data
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  async updateUserPlatform(data) {
    try {
      const response = await axiosInstance.put("/user/platform", data);
      console.log("add device", data);

      return response.data;
    } catch (error) {
      return error;
    }
  },

  async contactUs(data) {
    try {
      const response = await axiosInstancePlexaarEmailApi.post(
        "/send/contactme",
        data
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },
  // Add more API service functions as needed
};
export { axiosInstance };
export default apiServices;
